'use client';
/* eslint-disable tailwindcss/no-custom-classname */
import type { MouseEvent } from 'react';
import { DISCLAIMER_ANCHOR_ID } from './constants';
import { DisclaimerProps } from './types';

export const ShortDisclaimer = ({
  linkLabel,
  shortText,
}: DisclaimerProps): JSX.Element | null => {
  if (!shortText && !linkLabel) {
    return null;
  }

  const handleLinkClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document
      .getElementById(DISCLAIMER_ANCHOR_ID)
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="rounded-radius/card-inner border border-borders/default bg-fill/alternative-1 p-spacing/gap/soft-12px">
      <p className="mhg-alpha-caption text-text/secondary-lighter">
        {linkLabel && (
          <a
            href={`#${DISCLAIMER_ANCHOR_ID}`}
            onClick={handleLinkClick}
            className="font-font-weight/table-header underline"
          >
            {linkLabel}
          </a>
        )}
        {linkLabel && shortText ? ': ' : ''}
        <span>{shortText}</span>
      </p>
    </div>
  );
};
